export const option_q_type = [
  { label: "近視治療", value: 1 },
  { label: "光學控制", value: 2 },
];

export const option_enabled = [
  { label: "啟用", value: 1 },
  { label: "停用", value: 0 },
];

export const option_parent = [
  { label: "父", value: 1 },
  { label: "母", value: 2 },
];

export const option_sex = [
  { label: "男", value: 1 },
  { label: "女", value: 2 },
];

export const option_education = [
  { label: "國中以下", value: 1 },
  { label: "高中", value: 2 },
  { label: "大學", value: 3 },
  { label: "研究所以上", value: 4 },
];

export const option_want = [
  { label: "願意", value: 1 },
  { label: "不願意", value: 2 },
];

export const option_yesno = [
  { label: "是", value: 1 },
  { label: "否", value: 2 },
];

export const option_5_score = [
  { label: 1, value: 1 },
  { label: 2, value: 2 },
  { label: 3, value: 3 },
  { label: 4, value: 4 },
  { label: 5, value: 5 },
];

export const option_correct = [
  { label: "對", value: 1 },
  { label: "不對", value: 2 },
  { label: "不確定", value: 3 },
];

export const option_treatment_type = [
  { label: "點阿托品眼藥水", value: 1 },
  { label: "光學矯正-配戴角膜塑型片", value: 2 },
  { label: "光學矯正-配戴近視控制專用日拋", value: 3 },
  { label: "光學矯正-配戴近視控制框架鏡片", value: 4 },
  { label: "我選擇只接受對小孩最為舒服之治療方式", value: 5 },
  { label: "我不知道小孩偏好哪一種治療方式", value: 6 },
  { label: "我希望其他人(例如醫療團隊)幫我的小孩決定如何治療", value: 7 },
  { label: "我想要再與我的主治醫師討論我為小孩做的決定", value: 8 },
  {
    label:
      "我想要再與其他人（包含配偶、小孩、朋友或第二意見提供者…）討論我的決定",
    value: 9,
  },
  { label: "不進行任何治療，原因", value: 10 },
];

export const option_treatment_consider = [
  {
    value: 1,
    label: "較好的視覺改善",
    remark: "所有的光學矯正治療都可以有好的視覺品質",
  },
  {
    value: 2,
    label: "害怕畏光、近視模糊、過敏",
    remark: "可選擇光學矯正搭配低濃度阿托品眼藥",
  },
  {
    value: 3,
    label: "害怕沒點阿托品眼藥度數反彈更嚴重",
    remark: "應與醫師討論阿托品眼藥濃度與使用時間後再行決定",
  },
  {
    value: 4,
    label: "喜愛運動活動",
    remark: "可選擇日拋兒控隱形眼鏡或角膜塑型之選項",
  },
  {
    value: 5,
    label: "害怕有角膜感染風險",
    remark: "可選擇阿托品眼藥或近視控制框架鏡片",
  },
  {
    value: 6,
    label: "擔心較多的費用",
    remark: "可選擇阿托品眼藥配合單焦眼鏡",
  },
  {
    value: 7,
    label: "需要花費時間協助兒童",
    remark: "可選擇阿托品眼藥或是日拋兒控隱形眼鏡",
  },
  {
    value: 8,
    label: "無法有6-8小時睡眠",
    remark: "日拋兒控隱形眼鏡或近視控制框架鏡片",
  },
  {
    value: 9,
    label: "不喜歡戴眼鏡",
    remark: "可選擇日拋兒控隱形眼鏡或角膜塑型之選項",
  },
  {
    value: 10,
    label: "害怕隱形眼鏡造成乾眼",
    remark: "可選擇阿托品眼藥配合框架眼鏡",
  },
];

export const option_treatment_correct = [
  {
    value: 1,
    label:
      "近視造成的視覺模糊主要是由於無限遠的影像落焦成像在視網膜之前所形成。",
    options: option_correct,
  },
  {
    value: 2,
    label: "實證的研究證實目前近視治療是有效的。",
    options: option_correct,
  },
  {
    value: 3,
    label: "睡前點阿托品(Atropine)眼藥可以減緩近視度數增加，眼軸變長。",
    options: option_correct,
  },
  {
    value: 4,
    label: "光學矯正如配戴角膜塑型片可依照個人需求決定配戴與否。",
    options: option_correct,
  },
  {
    value: 5,
    label: "光學矯正如角膜塑型治療就絕對不必使用阿托品眼藥。",
    options: option_correct,
  },
  {
    value: 6,
    label: "醫師建議應該僅採用舒適之處置就好時，家長只能接受。",
    options: option_correct,
  },
];

export const option_treatment_satisfaction = [
  {
    value: 1,
    label: "您覺得您做了最適合您的小孩的近視治療決定嗎？",
    options: option_yesno,
  },
  {
    value: 2,
    label: "您知道近視治療每一個選項的優點及缺點嗎？",
    options: option_yesno,
  },
  {
    value: 3,
    label: "您清楚近視治療對您的小孩最重要的優點及缺點嗎？",
    options: option_yesno,
  },
  {
    value: 4,
    label: "您有得到足夠的幫助及建議來為小孩做決定嗎？",
    options: option_yesno,
  },
];

export const option_treatment_type_less = [
  { label: "點阿托品眼藥水", value: 1 },
  { label: "光學矯正-配戴角膜塑型片", value: 2 },
  { label: "光學矯正-配戴近視控制專用日拋", value: 3 },
  { label: "光學矯正-配戴近視控制框架鏡片", value: 4 },
  { label: "我選擇只接受對小孩最為舒服之治療方式", value: 5 },
];

export const option_treatment_undo = [
  { label: "我希望其他人(例如醫療團隊)幫我的小孩決定如何治療", value: 1 },
  { label: "我還是不知道該給予小孩哪一種治療方式", value: 2 },
  { label: "其他", value: 3 },
];

export const option_control_type = [
  { label: "光學矯正-配戴角膜塑型片", value: 1 },
  { label: "光學矯正-配戴近視控制專用日拋", value: 2 },
  { label: "光學矯正-配戴近視控制框架鏡片", value: 3 },
  { label: "我不知道小孩偏好哪一種治療方式", value: 4 },
  { label: "我希望便宜一點的眼鏡", value: 5 },
  { label: "我想要再與眼科專業人員討論我為小孩做的決定", value: 6 },
  {
    label:
      "我想要再與其他人（包含配偶、小孩、朋友或第二意見提供者…）討論我的決定",
    value: 7,
  },
  { label: "不配戴眼鏡，原因", value: 8 },
];

export const option_control_consider = [
  {
    value: 1,
    label: "較好的視覺改善",
    remark: "所有的治療方式，治療過程都可以有好的視覺品質",
  },
  {
    value: 2,
    label: "介意外貌(同儕看法)",
    remark: "可選擇日拋兒控隱形眼鏡或角膜塑型之選項",
  },
  {
    value: 3,
    label: "喜愛運動活動",
    remark: "可選擇日拋兒控隱形眼鏡或角膜塑型之選項",
  },
  {
    value: 4,
    label: "害怕有角膜感染風險",
    remark: "可選擇Atropine或近視控制框架鏡片",
  },
  {
    value: 5,
    label: "較多的費用",
    remark: "可選擇阿托品配合單焦眼鏡",
  },
  {
    value: 6,
    label: "需要花費時間協助兒童",
    remark: "可選擇阿托品或是日拋兒控隱形眼鏡",
  },
  {
    value: 7,
    label: "無法有6-8小時睡眠",
    remark: "近視控制框架鏡片",
  },
  {
    value: 8,
    label: "不喜歡戴眼鏡",
    remark: "可選擇日拋兒控隱形眼鏡或角膜塑型之選項",
  },
  {
    value: 9,
    label: "害怕隱形眼鏡造成乾眼",
    remark: "可選擇阿托品配合單焦眼鏡",
  },
];

export const option_control_correct = [
  {
    value: 1,
    label: "接受控制近視度數治療之後，不須改變生活用眼習慣。",
    options: option_correct,
  },
  {
    value: 2,
    label: "周邊離焦的原理應該有助於控制眼軸生長。",
    options: option_correct,
  },
  {
    value: 3,
    label:
      "兒控日拋隱形眼鏡可以自己決定配戴時間，時數不足便自行取下控制成效不變。",
    options: option_correct,
  },
  {
    value: 4,
    label: "兒控日拋隱形眼鏡需於摘下時搭配框架眼鏡使用。",
    options: option_correct,
  },
  {
    value: 5,
    label: "已配戴兒控近視框架眼鏡治療就絕對不必使用阿托品眼藥。",
    options: option_correct,
  },
  {
    value: 6,
    label: "希望孩子配的眼鏡能減度數，這樣度數就不會跳太快。",
    options: option_correct,
  },
];

export const option_control_satisfaction = [
  {
    value: 1,
    label: "您覺得您做了最適合您的小孩的眼鏡選擇嗎？",
    options: option_yesno,
  },
  {
    value: 2,
    label: "您知道眼鏡選項每一個選項的優點及缺點嗎？",
    options: option_yesno,
  },
  {
    value: 3,
    label: "您清楚不同眼鏡的治療效果嗎？",
    options: option_yesno,
  },
  {
    value: 4,
    label: "您有得到足夠的幫助及建議來為小孩選擇眼鏡嗎？",
    options: option_yesno,
  },
];

export const option_control_type_less = [
  { label: "配戴角膜塑型片", value: 1 },
  { label: "配戴近視控制專用日拋", value: 2 },
  { label: "配戴近視控制框架鏡片", value: 3 },
  { label: "多焦點鏡片", value: 4 },
  { label: "我選擇只接受對小孩最為舒服之治療方式", value: 5 },
];

export const option_control_undo = [
  { label: "我希望其他人(例如醫療團隊)幫我的小孩決定配戴的眼鏡", value: 1 },
  { label: "我還是不知道該給予小孩配戴哪一種眼鏡", value: 2 },
  { label: "其他", value: 3 },
];
